<ng-container *ngIf="isLoggedIn$ | async; let loggedIn; else loadingTemp">
  <app-main-layout *ngIf="loggedIn?.username">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
  </app-main-layout>
  <router-outlet *ngIf="!loggedIn?.username"></router-outlet>
</ng-container>
<ng-container *ngIf="loading$ | async; then loadingTemp"></ng-container>

<ng-template #loadingTemp>
  <div class="fixed top-0 left-0 w-[100vw] h-[100vw] bg-gray-400/50 cursor-not-allowed z-[500]">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>